module.exports = __webpack_public_path__ + "img/mec-conceito4.421ea78c.png";